// Museum logo. When museum-config supplies a `logoUrl` we trust it to be the
// complete lockup and show it alone; otherwise we fall back to the bundled
// Destino Valparaíso boat mark plus the museum name as text.

import { useKioskConfig } from "../config/KioskConfigContext";

const DEFAULT_LOGO = "/brand/logo-iso.png";
// logo-iso.png is 372×244 (≈3:2). The .brand__logo class drives the rendered
// size; these are layout hints (and satisfy the no-CLS lint rule).
const DEFAULT_RATIO = 372 / 244;

export function BrandMark({
  size = "md",
  onDark = false,
}: {
  size?: "md" | "lg";
  onDark?: boolean;
}) {
  const { museumName, museumTagline, logoUrl } = useKioskConfig();
  const className = [
    "brand",
    size === "lg" ? "brand--lg" : "",
    onDark ? "brand--on-dark" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const baseH = size === "lg" ? 80 : 44;

  if (logoUrl) {
    return (
      <span className={className}>
        <img
          alt={museumName}
          className="brand__logo"
          height={baseH}
          src={logoUrl}
          width={Math.round(baseH * DEFAULT_RATIO)}
        />
      </span>
    );
  }

  return (
    <span className={className}>
      <img
        alt=""
        className="brand__logo"
        height={baseH}
        src={DEFAULT_LOGO}
        width={Math.round(baseH * DEFAULT_RATIO)}
      />
      <span className="brand__text">
        <span className="brand__name">{museumName}</span>
        {museumTagline ? (
          <span className="brand__tag">{museumTagline}</span>
        ) : null}
      </span>
    </span>
  );
}
